import { InputOption, ICalendarText } from "../../classes/index";
import { ExtendedActionType } from "./index";

export function receiveCalendarText(input: ICalendarText) {
    return {
        type: ExtendedActionType.ReceiveCalendarText,
        value: input
    }
}

export function requestCalendarText() {
    return {
        type: ExtendedActionType.RequestCalendarText
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/redux/actions/calendar-text-actions.ts